/**
 * Pipeline map UX feature flags (client evaluation / rollout).
 */

/**
 * When true, a tap on pipeline geometry outside the user's jurisdiction shows a
 * restricted popup (no operator link, asset details, or pipeline specs) instead
 * of silent no-op. Set `VITE_PIPELINE_MAP_JURISDICTION_DENIED_POPUP=false` to disable.
 */
export const PIPELINE_MAP_SHOW_JURISDICTION_DENIED_POPUP =
  (import.meta.env.VITE_PIPELINE_MAP_JURISDICTION_DENIED_POPUP as string | undefined)?.trim() !==
  'false'

/**
 * When the jurisdiction-denied popup is shown, include reverse-geocoded county/state
 * (public location from the tap point, not pipeline vector attributes).
 */
export const PIPELINE_MAP_JURISDICTION_DENIED_SHOW_LOCATION = false
